import CircularProgress from '@mui/material/CircularProgress';



export const ExportButton = ({exportInProgress, exportData}) => {

    return (<div className="mt-20 mb-20"> 
    <div className="current-locations-sidebar-box2">
        <div className="sidbar-primary-text">Download Report</div>
        
        {exportInProgress ?    <div className="ml-auto pt-3">     <CircularProgress size={24} /> </div> :
        <div onClick={exportData} className="password-account ml-auto">Export</div>
        }

    </div>
    </div>
    )
}